import HomeModules from "./HomeModules";
import HomeProfileBox from "./HomeProfileBox";

const Home = ({ data }) => {
  return (
    <div className="flex sm:flex-wrap 2xs:max-sm:flex-col flex-row-reverse h-[calc(100vh-9em)] 2xs:max-lg:h-[calc(100vh-7em)] 2xs:max-md:h-[calc(100vh-7em)] overflow-auto">
      <HomeProfileBox data={data} />
      <HomeModules />
    </div>
  );
};
export default Home;
